export default __webpack_public_path__ + "static/media/20.ef1de03a.jpg";